module.exports = __webpack_public_path__ + "img/29.0f7c9cee.png";